import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-4">{contactInfo.title}</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">{contactInfo.description}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <div className="flex items-center gap-3 bg-background-50 px-5 py-3 rounded-lg">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-background-50 px-5 py-3 rounded-lg">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className="ri-qq-line text-lg text-accent-600"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400">QQ群</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.qq}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}